import React, { useState, useEffect } from "react";
import "./NewsletterModal.css";
import { useGetNewsletterQuery, useSubscribeToNewsletterMutation } from "../../redux/Apis/HomeSettings";
import { toast } from "react-toastify";
import icon from "../../shared/images/arrow.png"

const NewsletterModal = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [email, setEmail] = useState("");
  const { data: newsletterData, isLoading, error } = useGetNewsletterQuery();
  const [subscribeToNewsletter, { isLoading: isSubmitting }] = useSubscribeToNewsletterMutation();
  const newsletter = Array.isArray(newsletterData?.data) ? newsletterData.data.find((item) => item?._id && item.active !== false) : null;

  const handleClose = () => {
    setIsVisible(false);
    try { localStorage.setItem("newsletterClosed", "true"); } catch { /* Closing also works when storage is unavailable. */ }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    if (newsletter?._id && email.trim()) {
      try {
        await subscribeToNewsletter({ newsletter_id: newsletter._id, email: email.trim() }).unwrap();
        toast.success("Tack för att du prenumererar på Dolcehem");
        handleClose();
      } catch (error) {
        toast.error("Något gick fel. Försök igen.");
      }
    } else {
      toast.error("Newsletter information saknas. Försök igen senare.");
    }
  };

  useEffect(() => {
    try {
      if (localStorage.getItem("newsletterClosed") === "true") setIsVisible(false);
    } catch { /* Storage is optional. */ }
  }, []);

  if (!isVisible || isLoading || error || !newsletter) return null;

  return (
    <div className="newsletter-modal-overlay">
      <div className="newsletter-modal newsletter-modal-ellipse" role="dialog" aria-label="Dolcehems nyhetsbrev">
        <button className="newsletter-modal-close" onClick={handleClose} aria-label="Stäng">
          <span className="newsletter-modal-close-x">&times;</span>
        </button>
        <div className="newsletter-modal-content">
          <div className="newsletter-modal-icon">
            {/* Paper plane SVG icon */}
            <img 
            src={icon}
            height={50}
            alt=""
            />
          </div>
          <div className="newsletter-modal-title">Dolcehem</div>
          <div className="newsletter-modal-desc">
            Håll dig uppdaterad med våra senaste nyheter och erbjudanden
          </div>
          <form className="newsletter-modal-form" onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Din e-postadress"
              aria-label="E-postadress till nyhetsbrevet"
              className="newsletter-modal-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button
              type="submit"
              className="newsletter-modal-submit"
              disabled={isSubmitting || !email.trim()}
            >
              {isSubmitting ? "Prenumererar…" : "Anmäl dig"}
            </button>
          </form>
          <div className="newsletter-modal-info">
            Du anmäler dig för att ta emot våra e-postutskick och kan när som helst avsluta prenumerationen.
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsletterModal;
